import React from 'react';
import { Home } from './pages/Home';
import { CartProvider } from './components/CartContext';
export function App() {
  return <CartProvider data-id="element-0">
      <Home data-id="element-1" />
    </CartProvider>;
}